import Page from "webPage/Page";

Page.register('page-template-search', () => {
    const query = Page.get_query();
    $('.js-search-term').text(query.search);

    if (query.search) {
        updateSearchResults(query);
    } else {
        const $results = $(".js-search-results");
        $results.html(
            eotwJSXFactory('p', null, ["Sorry, there were no results for your search"]),
        );
    }
});


async function updateSearchResults(query) {
    const $results = $(".js-search-results");

    try {
        const result = await getSearchResults(query);

        if (!result.success || !result.data.html) {
            $results.html(
                eotwJSXFactory('p', null, ["Sorry, there were no results for your search"]),
            );
            return;
        }

        $results.html(result.data.html);
    } catch (e) {
        console.warn(e);
        $results.html(
            eotwJSXFactory('p', null, ["Sorry, there was a problem getting your search results. Please try again later"]),
        );
    }
}

async function getSearchResults(query) {
    return Ajax.get('eotw',  'search', query);
}

export {getSearchResults};